import React, { PureComponent } from 'react';
import { withRouter } from 'react-router';

class App extends PureComponent {
  render() {
    const { children, location } = this.props;
    return children;
  }
}

export default App;
